import { campaignAPI } from "@api";
import { ArrowLeftColor, ComponentMenuBar, ModuleEmpty } from "@components";
import { PATH_MY_STATE_LEADERBOARD } from "@configs";
import { IMemberTier } from "@interfaces";
import { selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { Skeleton } from "antd";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import styled from "styled-components";
import { CrownCustom } from "../icon/CrownCustom";

interface IProps {
    socials: JSX.Element[];
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentMyStatePage = (props: IProps) => {
    //page props
    const { socials } = props;
    const { t } = useTranslation();
    const { id } = useParams<{ id: string }>();
    const merchant = useSelector(selectMerchant);
    const history = useHistory();
    const { themes } = useSelector(selectMerchant);

    const [menuTab, setMenuTab] = useState<number>(0);
    const [campaign, setCampaign] = useState<any>();
    const [myData, setMyData] = useState<any>();
    const [historyData, setHistoryData] = useState<any>([]);
    const [isLoading, setIsloading] = useState(true);
    const [userList, setUserList] = useState<any>([]);
    const onChange = (key: string | string[]) => {
        //
    };

    const getCampaign = async () => {
        try {
            const getMydata = await campaignAPI.getMyCampaignData(id);
            const get = await campaignAPI.getCampaign(id);
            const getUser = await campaignAPI.getUserCampaignData(id, "");
            const getHistory = await campaignAPI.getHistoryActivity(
                id,
                `?status=${
                    menuTab === 0
                        ? ""
                        : menuTab === 1
                        ? "PENDING"
                        : menuTab === 2
                        ? "APPROVED"
                        : "REJECTED"
                }`
            );
            if (getMydata.data) {
                setMyData(getMydata.data);
                setIsloading(false);
            }
            if (getUser.data) {
                setUserList(getUser.data);
            }
            if (get.data) {
                setCampaign(get.data);
            }
            if (getHistory.data?.doc[0]) {
                setHistoryData(getHistory.data?.doc[0]?.campaigns);
            }
        } catch (err: any) {
            // err.response?.data?.message ? error(err.response?.data?.message) : error(err.message);
            console.log(err);
        }
    };
    const getHistory = async (tap: number) => {
        const getHistory = await campaignAPI.getHistoryActivity(
            id,
            `?status=${
                tap === 0 ? "" : tap === 1 ? "PENDING" : tap === 2 ? "APPROVED" : "REJECTED"
            }`
        );
        if (getHistory.data?.doc[0]) {
            setHistoryData(getHistory.data?.doc[0]?.campaigns);
        }
    };

    useEffect(() => {
        getCampaign();
    }, []);

    const loadingComponent = (
        <StyledSkeleton>
            <Skeleton
                loading={true}
                active
                title={false}
                paragraph={{ rows: 3, width: [172, 220, 92] }}
            ></Skeleton>
        </StyledSkeleton>
    );
    // const leaderboardMechanic = campaign.mechanics.find(
    //     (mechanic: any) => mechanic.type === "LEADERBOARD"
    // );
    const findleaderboard = campaign?.mechanics?.find(
        (target: any) => target.type === "LEADERBOARD"
    );
    const getMyData = userList.find((user: any) => user.userId === myData.userId);

    return (
        <>
            <RenderMeta title={t("meta.mystate")} />
            <StlyedSocialMedia
                themeColor={themes?.themeColor!}
                campaginColor={campaign?.campaignColor}
            >
                <div className="back-arrow">
                    <ArrowLeftColor color={themes?.themeColor} onClick={() => history.goBack()} />
                    {/* <span>{t("page.back")}</span> */}
                </div>
                <div className="logo-survey">{t("page.campaign.stats")}</div>
                <Skeleton
                    className="loadingtop"
                    loading={isLoading}
                    active
                    title={true}
                    paragraph={false}
                >
                    {campaign?.mechanics?.some(
                        (mechanic: any) => mechanic.type === "LEADERBOARD"
                    ) && (
                        <div className="content-state-leaderboard">
                            <div className="layouttop-state-leaderboard">
                                <div className="box-state-leaderboard">
                                    <div className="title-state-leaderboard">
                                        {t("page.campaign.ranking")}
                                    </div>
                                    <div className="result-state-leaderboard">
                                        {getMyData.ranking + 1 !== 0 &&
                                        getMyData.ranking + 1 <= findleaderboard.numberOfRanking ? (
                                            <span>
                                                <CrownCustom
                                                    color={
                                                        findleaderboard.ranking[
                                                            getMyData.ranking - 1
                                                        ]?.color
                                                    }
                                                />
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {/* <img src="../../images/ic-crown-gold.png" alt="" /> */}

                                        {getMyData?.ranking + 1 > 0
                                            ? getMyData?.ranking + 1
                                            : "N/A"}
                                    </div>
                                </div>
                                <div className="box-state-leaderboard">
                                    <div className="title-state-leaderboard">
                                        {t("page.campaign.timeupload")}
                                    </div>
                                    <div className="result-state-leaderboard">
                                        {getMyData?.totalActivity}
                                    </div>
                                </div>
                                <div className="box-state-leaderboard">
                                    <div className="title-state-leaderboard">
                                        {t("page.campaign.totalpointscollected")}
                                    </div>
                                    <div className="result-state-leaderboard">
                                        <span>
                                            <img src="../../images/ic-coin-point.svg" alt="" />
                                        </span>
                                        {getMyData?.totalPoint}
                                    </div>
                                </div>
                            </div>
                            <div className="btn-state">
                                <StyledBtnState
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() =>
                                        history.push(PATH_MY_STATE_LEADERBOARD + "/" + id)
                                    }
                                >
                                    <span>
                                        <img src="../../images/ic-leaderboard-white.png" alt="" />
                                    </span>
                                    {t("page.campaign.leaderboard")}
                                </StyledBtnState>
                            </div>
                        </div>
                    )}
                </Skeleton>
                <div className="layout-content">
                    <div className="main-content">
                        <div className="tab-section">
                            <div
                                className={menuTab === 0 ? "menu-active" : ""}
                                onClick={() => {
                                    getHistory(0);
                                    setMenuTab(0);
                                }}
                            >
                                {t("page.campaign.total")}
                            </div>
                            <div
                                className={menuTab === 1 ? "menu-active" : ""}
                                onClick={() => {
                                    setMenuTab(1);
                                    getHistory(1);
                                }}
                            >
                                {t("page.campaign.pending")}
                            </div>
                            <div
                                className={menuTab === 2 ? "menu-active" : ""}
                                onClick={() => {
                                    setMenuTab(2);
                                    getHistory(2);
                                }}
                            >
                                {t("page.campaign.approve")}
                            </div>
                            <div
                                className={menuTab === 3 ? "menu-active" : ""}
                                onClick={() => {
                                    setMenuTab(3);
                                    getHistory(3);
                                }}
                            >
                                {t("page.campaign.reject")}
                            </div>
                        </div>

                        {menuTab === 0 && (
                            <>
                                <div className="box-content">
                                    <div className="wrapper-content-state">
                                        {historyData.length > 0 ? (
                                            <>
                                                {historyData?.map((data: any, index: number) => (
                                                    <div
                                                        className="layout-content-state"
                                                        key={index}
                                                    >
                                                        <div className="img-content-state">
                                                            <img src={data.imageUrl} alt="" />
                                                        </div>
                                                        <div className="title-content-state">
                                                            {data.activityType}
                                                        </div>
                                                        <div className="date-content-state">
                                                            {data.uploadedAt
                                                                ? format(
                                                                      new Date(data.uploadedAt),
                                                                      "DD/MM/YYYY HH:mm"
                                                                  )
                                                                : ""}
                                                        </div>
                                                        <div
                                                            className={
                                                                data.status === "PENDING"
                                                                    ? "status-content-state pending"
                                                                    : data.status === "APPROVED"
                                                                    ? "status-content-state approve"
                                                                    : "status-content-state rejected"
                                                            }
                                                        >
                                                            {data.status === "PENDING"
                                                                ? t("page.campaign.pending")
                                                                : data.status === "APPROVED"
                                                                ? t("page.campaign.approve")
                                                                : t("page.campaign.reject")}
                                                            {/* Pending */}
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        ) : historyData.length === 0 && isLoading ? (
                                            loadingComponent
                                        ) : (
                                            <StyledEmptyLayout>
                                                <ModuleEmpty description="No data" />
                                            </StyledEmptyLayout>
                                        )}
                                        {/* <div className="layout-content-state">
                                            <div className="img-content-state">
                                                <img src="../../images/img-state-01.png" alt="" />
                                            </div>
                                            <div className="title-content-state">
                                                ออกกำลังกาย Circuit
                                            </div>
                                            <div className="date-content-state">
                                                12/10/2023 23:00
                                            </div>
                                            <div className="status-content-state pending">
                                                Pending
                                            </div>
                                        </div>
                                        <div className="layout-content-state">
                                            <div className="img-content-state">
                                                <img src="../../images/img-state-01.png" alt="" />
                                            </div>
                                            <div className="title-content-state">
                                                ออกกำลังกาย Circuit
                                            </div>
                                            <div className="date-content-state">
                                                12/10/2023 23:00
                                            </div>
                                            <div className="status-content-state pending">
                                                Pending
                                            </div>
                                        </div>
                                        <div className="layout-content-state">
                                            <div className="img-content-state">
                                                <img src="../../images/img-state-01.png" alt="" />
                                            </div>
                                            <div className="title-content-state">
                                                ออกกำลังกาย Circuit
                                            </div>
                                            <div className="date-content-state">
                                                12/10/2023 23:00
                                            </div>
                                            <div className="point-content-state">+2 Points</div>
                                            <div className="status-content-state approve">
                                                Approve
                                            </div>
                                        </div>
                                        <div className="layout-content-state">
                                            <div className="img-content-state">
                                                <img src="../../images/img-state-01.png" alt="" />
                                            </div>
                                            <div className="title-content-state">
                                                ออกกำลังกาย Circuit
                                            </div>
                                            <div className="date-content-state">
                                                12/10/2023 23:00
                                            </div>
                                            <div className="point-content-state">+2 Points</div>
                                            <div className="status-content-state approve">
                                                Approve
                                            </div>
                                        </div>
                                        <div className="layout-content-state">
                                            <div className="img-content-state">
                                                <img src="../../images/img-state-01.png" alt="" />
                                            </div>
                                            <div className="title-content-state">
                                                ออกกำลังกาย Circuit
                                            </div>
                                            <div className="date-content-state">
                                                12/10/2023 23:00
                                            </div>
                                            <div className="status-content-state rejected">
                                                Rejected
                                            </div>
                                        </div>
                                        <div className="layout-content-state">
                                            <div className="img-content-state">
                                                <img src="../../images/img-state-01.png" alt="" />
                                            </div>
                                            <div className="title-content-state">
                                                ออกกำลังกาย Circuit
                                            </div>
                                            <div className="date-content-state">
                                                12/10/2023 23:00
                                            </div>
                                            <div className="status-content-state rejected">
                                                Rejected
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </>
                        )}
                        {menuTab === 1 && (
                            <>
                                <div className="box-content">
                                    <div className="wrapper-content-state">
                                        {historyData.length > 0 ? (
                                            <>
                                                {historyData?.map((data: any, index: number) => (
                                                    <div
                                                        className="layout-content-state"
                                                        key={index}
                                                    >
                                                        <div className="img-content-state">
                                                            <img src={data.imageUrl} alt="" />
                                                        </div>
                                                        <div className="title-content-state">
                                                            {data.activityType}
                                                        </div>
                                                        <div className="date-content-state">
                                                            {data.uploadedAt
                                                                ? format(
                                                                      new Date(data.uploadedAt),
                                                                      "DD/MM/YYYY HH:mm"
                                                                  )
                                                                : ""}
                                                        </div>
                                                        <div
                                                            className={
                                                                data.status === "PENDING"
                                                                    ? "status-content-state pending"
                                                                    : data.status === "APPROVED"
                                                                    ? "status-content-state approve"
                                                                    : "status-content-state rejected"
                                                            }
                                                        >
                                                            {data.status === "PENDING"
                                                                ? t("page.campaign.pending")
                                                                : data.status === "APPROVED"
                                                                ? t("page.campaign.approve")
                                                                : t("page.campaign.reject")}
                                                            {/* Pending */}
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        ) : historyData.length === 0 && isLoading ? (
                                            loadingComponent
                                        ) : (
                                            <StyledEmptyLayout>
                                                <ModuleEmpty description="No data" />
                                            </StyledEmptyLayout>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                        {menuTab === 2 && (
                            <>
                                <div className="box-content">
                                    <div className="wrapper-content-state">
                                        {historyData.length > 0 ? (
                                            <>
                                                {historyData?.map((data: any, index: number) => (
                                                    <div
                                                        className="layout-content-state"
                                                        key={index}
                                                    >
                                                        <div className="img-content-state">
                                                            <img src={data.imageUrl} alt="" />
                                                        </div>
                                                        <div className="title-content-state">
                                                            {data.activityType}
                                                        </div>
                                                        <div className="date-content-state">
                                                            {data.uploadedAt
                                                                ? format(
                                                                      new Date(data.uploadedAt),
                                                                      "DD/MM/YYYY HH:mm"
                                                                  )
                                                                : ""}
                                                        </div>
                                                        <div
                                                            className={
                                                                data.status === "PENDING"
                                                                    ? "status-content-state pending"
                                                                    : data.status === "APPROVED"
                                                                    ? "status-content-state approve"
                                                                    : "status-content-state rejected"
                                                            }
                                                        >
                                                            {data.status === "PENDING"
                                                                ? t("page.campaign.pending")
                                                                : data.status === "APPROVED"
                                                                ? t("page.campaign.approve")
                                                                : t("page.campaign.reject")}
                                                            {/* Pending */}
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        ) : historyData.length === 0 && isLoading ? (
                                            loadingComponent
                                        ) : (
                                            <StyledEmptyLayout>
                                                <ModuleEmpty description="No data" />
                                            </StyledEmptyLayout>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                        {menuTab === 3 && (
                            <>
                                <div className="box-content">
                                    <div className="wrapper-content-state">
                                        {historyData.length > 0 ? (
                                            <>
                                                {historyData?.map((data: any, index: number) => (
                                                    <div
                                                        className="layout-content-state"
                                                        key={index}
                                                    >
                                                        <div className="img-content-state">
                                                            <img src={data.imageUrl} alt="" />
                                                        </div>
                                                        <div className="title-content-state">
                                                            {data.activityType}
                                                        </div>
                                                        <div className="date-content-state">
                                                            {data.uploadedAt
                                                                ? format(
                                                                      new Date(data.uploadedAt),
                                                                      "DD/MM/YYYY HH:mm"
                                                                  )
                                                                : ""}
                                                        </div>
                                                        <div
                                                            className={
                                                                data.status === "PENDING"
                                                                    ? "status-content-state pending"
                                                                    : data.status === "APPROVED"
                                                                    ? "status-content-state approve"
                                                                    : "status-content-state rejected"
                                                            }
                                                        >
                                                            {data.status === "PENDING"
                                                                ? t("page.campaign.pending")
                                                                : data.status === "APPROVED"
                                                                ? t("page.campaign.approve")
                                                                : t("page.campaign.reject")}
                                                            {/* Pending */}
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        ) : historyData.length === 0 && isLoading ? (
                                            loadingComponent
                                        ) : (
                                            <StyledEmptyLayout>
                                                <ModuleEmpty description="No data" />
                                            </StyledEmptyLayout>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <ComponentMenuBar />
            </StlyedSocialMedia>
        </>
    );
};

const StyledSkeleton = styled.div`
    display: grid;
    .ant-skeleton {
        display: flex;
        background-color: #e8e8e8;
        padding: 12px;
        border-radius: 14px;
        width: 100%;
        margin-bottom: 8px;
        flex-direction: column;
        .ant-skeleton-paragraph {
            margin-top: 0 !important;
            margin-bottom: 15px;
            li {
                height: 10px;
                border-radius: 4px;
                margin-top: 8px;
            }
        }
    }
`;

const StyledBtnState = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: #fff;
    background-color: ${(p) => p.themeColor};
    border: none;
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 52px;
    width: 100%;
    span {
        margin-right: 10px;
        img {
            width: 16px;
        }
    }
    &:active {
        opacity: 0.8;
    }
`;
const StyledEmptyLayout = styled.div`
    .ant-empty-description {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #a5a5a5;
    }
`;
const StlyedSocialMedia = styled.div<{ themeColor: string; campaginColor: string }>`
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    background-color: ${(p) => p.campaginColor};
    background-position: right top;
    background-repeat: no-repeat;
    position: relative;
    .loadingtop {
        padding: 0 16px;
        .ant-skeleton-title {
            height: 120px;
            border-radius: 12px;
        }
    }
    .content-state-leaderboard {
        padding: 0 16px;
        .layouttop-state-leaderboard {
            display: grid;
            grid-template-columns: auto auto auto;
            gap: 24px;
            margin-bottom: 16px;
            .box-state-leaderboard:last-child {
                &:after {
                    display: none;
                }
            }
            .box-state-leaderboard {
                position: relative;
                &:after {
                    content: "";
                    width: 1px;
                    height: 90%;
                    background-color: rgb(255, 255, 255);
                    position: absolute;
                    right: -13px;
                    top: 50%;
                    transform: translateY(-50%);
                }
                .title-state-leaderboard {
                    display: block;
                    text-align: center;
                    color: ${(p) => p.themeColor};
                    font-size: 12px;
                    margin-bottom: 10px;
                }
                .result-state-leaderboard {
                    width: 100%;
                    border-radius: 8px;
                    background-color: #fff;
                    padding: 10px 0px;
                    display: flex;
                    -webkit-box-align: center;
                    align-items: center;
                    -webkit-box-pack: center;
                    justify-content: center;
                    font-size: 18px;
                    font-weight: 600;
                    color: #193578;
                    span {
                        margin-right: 10px;
                        img {
                            width: 20px;
                        }
                        svg {
                            width: 20px;
                            position: relative;
                            top: -4px;
                        }
                    }
                }
            }
        }
    }
    .btn-page {
        margin: 16px 0;
        position: fixed;
        bottom: 16px;
        left: 16px;
        width: calc(100% - 32px);
    }
    .layout-content {
        position: absolute;
        margin-top: -50px;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        background-color: #f4f6fa;
        padding: 24px 16px 50px;
        overflow: hidden;
        bottom: 0;
        width: 100%;
        height: 70dvh;
        .main-content {
            .tab-section {
                display: flex;
                justify-content: flex-start;
                grid-gap: 30px;
                color: ${(p) => p.themeColor};
                color: #9daaae;
                font-size: 16px;
                font-weight: 500;
                cursor: pointer;
                padding-bottom: 8px;
                .menu-active {
                    // border-bottom: 2px solid ${(p) => p.themeColor};
                    // color: ${(p) => p.themeColor};
                    color: #000;
                    font-weight: 600;
                    position: relative;
                    &:after {
                        content: "";
                        position: absolute;
                        width: 20px;
                        height: 3px;
                        bottom: -8px;
                        left: 50%;
                        transform: translateX(-50%);
                        border-radius: 4px;
                        background-color: ${(p) => p.themeColor};
                        /* background: linear-gradient(
                            342deg,
                            rgba(162, 26, 115, 1) 0%,
                            rgba(227, 62, 59, 1) 100%
                        ); */
                    }
                }
            }
            .box-content {
                margin-top: 16px;
                height: 60vh;
                overflow: scroll;
                display: block;
                padding-bottom: 50px;
                .wrapper-content-state {
                    .layout-content-state {
                        padding: 12px 60px 12px 130px;
                        position: relative;
                        background-color: #fff;
                        border-radius: 12px;
                        min-height: 105px;
                        margin-bottom: 6px;
                        .img-content-state {
                            position: absolute;
                            left: 15px;
                            top: 15px;
                            width: 100px;
                            height: 75px;
                            border-radius: 12px;
                            overflow: hidden;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }
                        .title-content-state {
                            font-size: 14px;
                            font-weight: 500;
                            margin-bottom: 5px;
                        }
                        .date-content-state {
                            padding-left: 20px;
                            background-image: url(../../images/ic-state-date.png);
                            background-position: left;
                            background-size: 12px;
                            font-size: 12px;
                            color: #9b9b9b;
                            margin-bottom: 5px;
                            background-repeat: no-repeat;
                        }
                        .point-content-state {
                            padding-left: 20px;
                            background-image: url(../../images/ic-coin-point.svg);
                            background-position: left;
                            background-repeat: no-repeat;
                            background-size: 16px;
                            color: #26c2a4;
                            font-size: 12px;
                            margin-bottom: 5px;
                            font-weight: 500;
                        }
                        .status-content-state {
                            position: absolute;
                            right: 12px;
                            top: 12px;
                            padding: 4px 8px;
                            font-size: 11px;
                            color: #fff;
                            border-radius: 30px;
                            width: 85px;
                            text-align: center;
                        }
                        .pending {
                            background-color: #76c0d9;
                        }
                        .approve {
                            background-color: #26c2a4;
                        }
                        .rejected {
                            background-color: #e53223;
                        }
                    }
                }
            }
        }
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        top: 15px;
        display: flex;
        align-items: center;
        z-index: 1;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    .logo-survey {
        font-size: 20px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
        text-align: center;
        margin-bottom: 30px;
        padding-top: 15px;
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
`;

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.theme.colors.card};
    // background: ${(p) => p.themeColor};
    // border: 0.5px solid ${(p) => p.themeColor};
    border: none;
    background: linear-gradient(342deg, rgba(162, 26, 115, 1) 0%, rgba(227, 62, 59, 1) 100%);
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 48px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;
